@if (store) {
<div>
    @if(store.isOpenToday && store.isOpenNow) {
    <span class="col-3 s1 ">{{'Open' | translate}}</span>
    <span class="p1 col-11">
        <span class="p-l-3 p-r-3 inline-block">•</span>{{'Closes at' | translate}}
        {{store.todayOpeningHours?.close}}
    </span>
    }@else{

    <span>
        <span class="col-2 s1 p1">{{'Closed' | translate}}</span>
    </span>
    }
</div>
}